import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "no-tabs notifications-settings" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "notifications-settings-custom-modal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxColumnFixing = _resolveComponent("DxColumnFixing")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_notifications_settings_modal = _resolveComponent("notifications-settings-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DxDataGrid, {
      ref: "notificationsSettingsGrid",
      "data-source": _ctx.customDataSource,
      "allow-column-reordering": true,
      "allow-column-resizing": true,
      "column-auto-width": true,
      "column-hiding-enabled": true,
      "hover-state-enabled": true,
      "remote-operations": { paging: true, sorting: true, filtering: true },
      "show-borders": true,
      "show-column-lines": true,
      scrolling: _ctx.scrollingConfig,
      onSelectionChanged: _ctx.onSelectionChanged,
      class: "notifications-settings-grid"
    }, {
      headerImeiTemplate: _withCtx(() => [
        _createElementVNode("span", null, [
          _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fa fa-barcode" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.notificationsSettings.dataGrids.imeiOrRegistration')), 1)
        ])
      ]),
      headerSmsTemplate: _withCtx(() => [
        _createElementVNode("span", null, [
          _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fa fa-sms" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.notificationsSettings.dataGrids.sendBySms')), 1)
        ])
      ]),
      headerEmailTemplate: _withCtx(() => [
        _createElementVNode("span", null, [
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fa fa-envelope" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.notificationsSettings.dataGrids.sendByEmail')), 1)
        ])
      ]),
      headerMercureTemplate: _withCtx(() => [
        _createElementVNode("span", null, [
          _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fa fa-bolt" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.notificationsSettings.dataGrids.sendByMercure')), 1)
        ])
      ]),
      imeiCellTemplate: _withCtx(({ data }) => [
        _createElementVNode("div", null, [
          (data.data.vehicles && data.data.vehicles.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.getRegistrationNumbers(data.data.vehicles)), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t('components.notificationsSettings.dataGrids.noRegistration')), 1)
              ])),
          _createElementVNode("div", null, [
            _createElementVNode("small", null, _toDisplayString(data.data.imei), 1)
          ])
        ])
      ]),
      default: _withCtx(() => [
        (_ctx.adminOrBoss)
          ? (_openBlock(), _createBlock(_component_DxSelection, {
              key: 0,
              "show-check-boxes-mode": _ctx.showCheckBoxesMode,
              mode: "multiple"
            }, null, 8, ["show-check-boxes-mode"]))
          : _createCommentVNode("", true),
        _createVNode(_component_DxHeaderFilter, { visible: true }),
        _createVNode(_component_DxPaging, { "page-size": 10 }),
        _createVNode(_component_DxPager, {
          "allowed-page-sizes": [10, 20, 25],
          "show-info": true,
          "show-navigation-buttons": true,
          "show-page-size-selector": true,
          visible: true
        }),
        _createVNode(_component_DxFilterRow, { visible: false }),
        _createVNode(_component_DxColumnFixing, { enabled: true }),
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          width: 140,
          placeholder: _ctx.$t('components.notificationsSettings.dataGrids.search')
        }, null, 8, ["placeholder"]),
        _createVNode(_component_DxColumn, {
          "data-field": "imei",
          caption: _ctx.$t('components.notificationsSettings.dataGrids.imei'),
          width: _ctx.columnWidths.imei,
          "header-cell-template": "headerImeiTemplate",
          "cell-template": "imeiCellTemplate"
        }, null, 8, ["caption", "width"]),
        _createVNode(_component_DxColumn, {
          "data-field": "notification_settings.send_by_sms",
          caption: _ctx.$t('components.notificationsSettings.dataGrids.sendBySms'),
          "data-type": "boolean",
          width: _ctx.columnWidths.sendBySms,
          alignment: "center",
          "header-cell-template": "headerSmsTemplate"
        }, null, 8, ["caption", "width"]),
        _createVNode(_component_DxColumn, {
          "data-field": "notification_settings.send_by_email",
          caption: _ctx.$t('components.notificationsSettings.dataGrids.sendByEmail'),
          "data-type": "boolean",
          width: _ctx.columnWidths.sendByEmail,
          alignment: "center",
          "header-cell-template": "headerEmailTemplate"
        }, null, 8, ["caption", "width"]),
        _createVNode(_component_DxColumn, {
          "data-field": "notification_settings.send_by_mercure",
          caption: _ctx.$t('components.notificationsSettings.dataGrids.sendByMercure'),
          "data-type": "boolean",
          width: _ctx.columnWidths.sendByMercure,
          alignment: "center",
          "header-cell-template": "headerMercureTemplate"
        }, null, 8, ["caption", "width"]),
        _createVNode(_component_DxColumn, {
          type: "buttons",
          width: _ctx.columnWidths.buttons
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxButton, {
              hint: _ctx.$t('components.notificationsSettings.dataGrids.edit'),
              icon: "edit",
              onClick: _ctx.openEditModal
            }, null, 8, ["hint", "onClick"])
          ]),
          _: 1
        }, 8, ["width"])
      ]),
      _: 1
    }, 8, ["data-source", "scrolling", "onSelectionChanged"]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_notifications_settings_modal, {
        ref: "notificationsSettingsModalRef",
        onEmittedRefreshGrid: _ctx.refreshDataGrid
      }, null, 8, ["onEmittedRefreshGrid"])
    ])
  ]))
}